import React from 'react';
import { useContext } from 'react';
import capitalise from '../../../utils/capitalise';

import { StationInfoObj } from '../../types';
import StationInfoContext from '../StationInfoContext';
import { crawlerDuplicateAvoidStyle } from '../../../utils/commonUtils';
import { trackClickEventProp61 } from '../../../utils/omnitureUtils';
import { SEO_STATION_PAGE } from '../../../utils/RailsSEOConstants';
type StationDetailsProps = {
  stationInfo: StationInfoObj;
  title: string;
  alternatePageUrl: {
    title: string;
    pageUrl: string;
  };
};

export default function StationDetails({ stationInfo, title, alternatePageUrl }: StationDetailsProps) {
  const stationData = useContext(StationInfoContext);
  return (
    <section>
      <div className="navigationUrl">
        <h3 className="railSeoWrap__railDetails--title desktopShow capText appendTop15">{title}</h3>
        {
          <p className="stationUrl">
            <a
              href={alternatePageUrl.pageUrl}
              onClick={() => trackClickEventProp61(SEO_STATION_PAGE, 'rail_seo_train_switch_hindi')}
            >
              {alternatePageUrl.title}
            </a>
          </p>
        }
      </div>
      <div className="appendTop15 mobileShow"></div>
      <div className="railSeoWrap__railDetails">
        <h3 style={crawlerDuplicateAvoidStyle} className="railSeoWrap__railDetails--title mobileShow">
          {title}
        </h3>
        <div>
          <span>{stationData.stationInfo['column']['code']}</span>
          <span>{stationInfo.code}</span>
        </div>
        <div>
          <span>{stationData.stationInfo['column']['name']}</span>
          <span>{capitalise(stationInfo.name)}</span>
        </div>
        <div>
          <span>{stationData.stationInfo['column']['city']}</span>
          <span>{stationInfo.city || 'NA'}</span>
        </div>
        <div>
          <span>{stationData.stationInfo['column']['zone']}</span>
          <span>{stationInfo.railwayZone}</span>
        </div>
        <div>
          <span>{stationData.stationInfo['column']['location']}</span>
          <span className="station_name">
            <span className="appendBottom10 mapIcon">&nbsp;</span>
            <a
              href={`https://www.google.com/maps/@${stationInfo.location.lat},${stationInfo.location.lng},20z`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {stationData.miscellaneous['SEE ON MAP']}
            </a>
          </span>
        </div>
      </div>
    </section>
  );
}
